import { render, staticRenderFns } from "./analysis-text-review.vue?vue&type=template&id=57e11fc1&"
import script from "./analysis-text-review.vue?vue&type=script&lang=ts&"
export * from "./analysis-text-review.vue?vue&type=script&lang=ts&"
import style0 from "./analysis-text-review.vue?vue&type=style&index=0&id=57e11fc1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports